import { Text as BaseText } from '@react-pdf/renderer';
import React from 'react';
import { Box, Flex } from '.';

export default function CircleIcon({ value, label }) {
  return (
    <Box
      style={{
        backgroundColor: '#ffffff',
        border: '1px solid, #0000000',
        height: 50,
        width: 50,
        borderRadius: 25,
        position: 'relative',
      }}
    >
      <Flex
        style={{
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'absolute',
          left: 2,
          right: 2,
        }}
      >
        <BaseText
          style={{
            fontSize: 12,
            marginBottom: 2,
          }}
        >
          {value}
        </BaseText>
        <BaseText
          style={{
            fontSize: 8,
          }}
        >
          {label}
        </BaseText>
      </Flex>
    </Box>
  );
}
